import { useEffect } from "react";

import { Traveller } from "@/types/Traveller";
import { TripDetails } from "@/types/TripDetails";

import { defaultFinishButtonClickData } from "./default-finish-button-click-types";
import { FinishButtonClickType } from "./finish-button-click-event";

export interface DashboardWindow extends Window {
  dataLayer?: FinishButtonClickType[];
}

// function to get TripDetails dynamic event data
const getTripDetailsEventData = (tripDetails: TripDetails) => {
  return {
    trip_type: tripDetails.policyType ?? null,
    destination: tripDetails?.toLocation ?? null,
    destination_additions: null,
    trip_extra: tripDetails?.goingOnCruise ? "criuse" : "",
    cover_start_date: tripDetails?.startDate ?? null,
    cover_end_date: tripDetails?.endDate ?? null,
    travel_from: tripDetails?.fromLocation ?? null,
    travel_group_type: tripDetails?.partyType ?? null,
  };
};

// function to get Traveller dynamic event data
const getTravelerEventData = (traveler: Traveller) => {
  return {
    medical_condition_added: traveler.medical?.screeningStatus === "ACCEPTED",
    medical_index: traveler.medical?.mdIndex ?? 0,
  };
};

type FinishButtonClickProps = {
  tripDetails: TripDetails | null | undefined;
  travelerList: Traveller[] | null | undefined;
  ready: boolean;
};

// custom hook to handle FINISH button click event
const useFinishButtonClickEvent = (props: FinishButtonClickProps) => {
  const { tripDetails, travelerList, ready } = props;
  // function to handle FINISH button click event
  useEffect(() => {
    const handleFinishButtonClickEvent = () => {
      const dashboardWindow = window as DashboardWindow;
      dashboardWindow.dataLayer = dashboardWindow.dataLayer ?? [];

      if (tripDetails && travelerList) {
        const tripEventData = {
          ...defaultFinishButtonClickData,
          ...getTripDetailsEventData(tripDetails),
        };

        travelerList?.forEach((traveler) => {
          const eventData = {
            ...tripEventData,
            ...getTravelerEventData(traveler),
          };

          dashboardWindow.dataLayer?.push({ ...eventData });
        });
      }
    };

    if (ready) handleFinishButtonClickEvent();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);
};

export default useFinishButtonClickEvent;
